module.exports = __webpack_public_path__ + "img/time.854eae8f.svg";